var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatGemHealCanAddressCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.499 6.90958C20.8068 7.18283 20.9864 7.55968 20.9984 7.95728C21.0104 8.35487 20.8537 8.74066 20.5629 9.02982L11.5102 18.0309C11.3635 18.1765 11.1872 18.293 10.9917 18.3736C10.7962 18.4541 10.5855 18.4971 10.372 18.4999C10.1586 18.5027 9.94668 18.4652 9.74888 18.3898C9.55107 18.3144 9.37137 18.2026 9.22038 18.0609L4.42778 13.5603C4.1456 13.276 3.99197 12.8998 3.99927 12.5112C4.00657 12.1225 4.17423 11.7517 4.46693 11.4769C4.75963 11.202 5.1545 11.0446 5.56837 11.0377C5.98224 11.0308 6.38279 11.1751 6.68563 11.4401L10.3174 14.8485L18.2411 6.96958C18.5321 6.68054 18.9334 6.51185 19.3568 6.5006C19.7802 6.48935 20.191 6.63646 20.499 6.90958Z",
    fill: "#307A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatGemHealCanAddressCheckIcon);
export default __webpack_public_path__ + "static/media/whatGemHealCanAddressCheckIcon.f45bdbb4aa5953fb9299c1e163f1c14e.svg";
export { ForwardRef as ReactComponent };